import Lenis from 'lenis'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default class SmoothScroll {
	constructor() {
		if (SmoothScroll.instance) return SmoothScroll.instance

		this._lenis = null
		this.options = {}
		this.#init()

		SmoothScroll.instance = this
	}

	#init() {
		this.#registerScrollTrigger()
		this.#initLenis()
		this.#addGsapTicker()
	}

	#initLenis() {
		this.options = { allowNestedScroll: true, syncTouch: true }
		this._lenis = new Lenis(this.options)
	}

	#addGsapTicker() {
		this._lenis.on('scroll', ScrollTrigger.update)
		gsap.ticker.add(time => {
			this._lenis.raf(time * 1000)
		})
		gsap.ticker.lagSmoothing(0)
	}

	#registerScrollTrigger() {
		gsap.registerPlugin(ScrollTrigger)
	}

	get lenis() {
		return this._lenis
	}

	/** Hold (or release) user scrolling. Programmatic scrollTo still works while held. */
	lock(on) {
		on ? this._lenis.stop() : this._lenis.start()
	}

	/** Smooth-scroll to the top; resolves once there (immediately if already there). */
	scrollToTop() {
		if (this._lenis.scroll < 1) return Promise.resolve()
		return new Promise(resolve => {
			const timeout = setTimeout(resolve, 1500) // lenis can drop onComplete if the scroll is interrupted
			this._lenis.scrollTo(0, {
				duration: 0.8,
				force: true, // runs inside a visit, while user scrolling is locked
				onComplete: () => {
					clearTimeout(timeout)
					resolve()
				},
			})
		})
	}
}
